import {DayName} from '@lib/infrastructure';
import {withPayloadType} from '@lib/utils';
import {createAction} from '@reduxjs/toolkit';
import {AppThunk} from '../../createStore';
import {WorkingHours} from '../../data';

export const setNewTimezone = createAction('ui/setNewTimezone', withPayloadType<string>());

export const setNewWorkingHoursPerDay = createAction(
  'ui/setNewWorkingHoursPerDay',
  (newTime: {startTimeLocal?: string; endTimeLocal?: string}, timeslot: number = 0, dayName?: DayName) => {
    return {
      payload: {
        dayName,
        newTime,
        timeslot,
      },
    };
  },
);

export const setWorkingHours = createAction('ui/setWorkingHours', withPayloadType<WorkingHours>());

export const setInitalWorkingHours = (): AppThunk => (dispatch, getState) => {
  const actualState = getState();
  const workingHours = actualState.data.meetings.userPreferences.workingHours;
  if (workingHours) {
    dispatch(setWorkingHours(workingHours));
  }
};
